import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import reactQueryClient from '@/utils/reactQueryClient';
import {CONTENT_LAB, CURRENT_SUBSCRIPTION} from '@/hooks/content-studio/consts';

function useInvalidateCurrentSubscription() {
  const location = useLocation();

  useEffect(() => {
    reactQueryClient.invalidateQueries({
      queryKey: [CONTENT_LAB, CURRENT_SUBSCRIPTION],
    });
  }, [location.pathname]);
}

export default useInvalidateCurrentSubscription;
